<template>
  <div class="p-grid">
    <Card class="fundo-card">
      <template #content>
        <center>
          <!-- form>
            <div
              class="p-fluid p-formgrid p-grid p-lg-6"
              style="min-width: 24rem; max-width: 100%; width: 60%"
            >
              <div class="p-col-12 p-md-10 p-lg-10 p-mt-4">
                <span class="p-input-icon-right p-float-label">
                  <i
                    style="cursor: pointer"
                    class="pi pi-search"
                    @click="realizarPesquisabyChaveBusca"
                  />
                  <InputText
                    id="inputChaveBusca"
                    type="text"
                    v-model="chaveBusca"
                    class="p-inputtext-lg"
                    @keyup.enter="realizarPesquisabyChaveBusca"
                  />
                  <label for="inputChaveBusca"
                    >Digite aqui os termos pelos quais deseja pesquisar
                    ...</label
                  >
                </span>
              </div>
              <div class="p-col-8 p-mt-4 p-lg-2" style="padding-left: 0.5rem">
                <Button
                  label="Buscar"
                  @click="realizarPesquisabyChaveBusca"
                  class="p-button-success"
                />
              </div>
            </div>
          </form>
          <br / -->
          <!-- Divider
            class="p-divider p-component p-divider-solid p-divider-center"
            style="color: lightgray; width: 90%"
          >
            <span class="p-tag">OU</span>
          </Divider -->
          <form>
            <div style="width: 90%">
              <div>
                <div class="p-fluid p-formgrid p-grid p-lg-8">
                  <div class="p-col-12 p-md-6 p-lg-12 p-mt-4">
                    <span class="p-float-label">
                      <InputText
                        id="inputConteudo"
                        type="text"
                        v-model="termosConteudo"
                        class="p-inputtext-lg"
                        @keyup.enter="realizarPesquisabyManyFields"
                      />
                      <label for="inputChaveBusca">Digite aqui os termos pelos quais deseja pesquisar no conteúdo do decisório.</label>
                    </span>
                  </div>
                  <div class="p-col-12 p-md-6 p-lg-3 p-mt-4">
                    <span class="p-float-label">
                      <InputText
                        id="inputNumProcesso"
                        type="text"
                        v-model="numProcesso"
                        class="p-inputtext-lg"
                        @keyup.enter="realizarPesquisabyManyFields"
                      />
                      <label for="inputNumProcesso">Número do Processo</label>
                    </span>
                  </div>
                  <div class="p-col-12 p-md-6 p-lg-3 p-mt-4">
                    <span class="p-float-label">
                      <InputText
                        id="inputAnoProcesso"
                        type="text"
                        v-model="anoProcesso"
                        class="p-inputtext-lg"
                        @keyup.enter="realizarPesquisabyManyFields"
                      />
                      <label for="inputAnoProcesso">Ano do Processo</label>
                    </span>
                  </div>
                  <div class="p-col-12 p-md-6 p-lg-3 p-mt-4">
                    <span class="p-float-label">
                      <InputText
                        id="inputNumDecisorio"
                        type="text"
                        v-model="numDecisorio"
                        class="p-inputtext-lg"
                        @keyup.enter="realizarPesquisabyManyFields"
                      />
                      <label for="inputNumDecisorio">Número do Decisório</label>
                    </span>
                  </div>
                  <div class="p-col-12 p-md-6 p-lg-3 p-mt-4">
                    <span class="p-input-icon-right p-float-label">
                      <InputText
                        id="inputAnoDecisorio"
                        type="text"
                        v-model="anoDecisorio"
                        class="p-inputtext-lg"
                        @keyup.enter="realizarPesquisabyManyFields"
                      />
                      <label for="inputAnoDecisorio">Ano do Decisório</label>
                    </span>
                  </div>
                  <div class="p-inputgroup">
                    <div class="p-col-12 p-md-6 p-lg-12 p-mt-4">
                      <span class="p-float-label">
                        <Dropdown
                          v-model="natureza"
                          :options="listaNaturezasJson"
                          style="width-max: 9%"
                          optionLabel="nomeNatureza"
                          :filter="true"
                          placeholder="Natureza"
                        />
                      </span>
                      <br />
                      <span class="p-float-label">
                        <Dropdown
                          v-model="relatorDecisorio"
                          :options="listaRelatoresJson"
                          optionLabel="nomeRelator"
                          :filter="true"
                          placeholder="Relator do Decisório"
                        />
                      </span>
                    </div>
                  </div>
                </div>

                <div class="p-fluid p-formgrid p-grid p-lg-8">
                  <div class="p-col-6 p-md-6 p-lg-6 p-mt-4">
                    <span class="p-float-label">
                      <Calendar
                        dateFormat="dd/mm/yy"
                        v-model="dataSessaoInicio"
                        :showIcon="true"
                      />
                      <label>Data Inicial Sessão</label>
                    </span>
                  </div>
                  <div class="p-col-6 p-md-6 p-lg-6 p-mt-4">
                    <span class="p-float-label">
                      <Calendar
                        dateFormat="dd/mm/yy"
                        v-model="dataSessaoFim"
                        :showIcon="true"
                      />
                      <label>Data Final Sessão</label>
                    </span>
                  </div>
                  <div class="p-inputgroup">
                    <div class="p-col-12 p-md-6 p-lg-12 p-mt-4">
                      <span>
                        <Dropdown
                          v-model="orgaoJulgador"
                          :options="listaOrgaosJulgadores"
                          optionLabel="name"
                          placeholder="Órgão Julgador"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-col-8 p-mt-4 p-lg-2" style="padding-left: 0.5rem">
                <Button
                  label="Buscar"
                  @click="realizarPesquisabyManyFields"
                  class="buscar-btn"
                />
              </div>
            </div>
          </form>
        </center>
      </template>
    </Card>
    <br />
    <div v-if="pesquisado" style="width: 100%">
      <DecisoriosLista :decisorios="this.dados" />
    </div>
  </div>
</template>
<script>

import DecisoriosLista from "./DecisoriosLista.vue";
import Decisorios from "../service/Decisorios";

export default {
  data() {
    return {
      chaveBusca: null,
      termosConteudo: null,
      anoProcesso: null,
      numProcesso: null,
      anoDecisorio: null,
      numDecisorio: null,
      relatorDecisorio: null,
      orgaoJulgador: null,
      dataSessaoInicio: null,
      dataSessaoFim: null,
      natureza: null,
      pesquisar: false,
      pesquisado: false,
      decisorioService: null,
      dados: [],
      listaRelatoresJson: [],
      listaNaturezasJson: [],
      listaOrgaosJulgadores: [
        { name: "Primeira Câmara", code: "Primeira Câmara" },
        { name: "Segunda Câmara", code: "Segunda Câmara" },
        { name: "Tribunal Pleno", code: "Tribunal Pleno" },
      ],
    };
  },
  mounted() {
    console.log(this);
  },
  methods: {
    consultarByUrlQuery() {
      console.log(this.$route.query);

      this.limparVariaveisFiltro();

      let temQuery = false;
      if ("conteudo" in this.$route.query) {
        this.termosConteudo = this.$route.query.conteudo;
        temQuery = true;
      }

      if ("natureza" in this.$route.query) {
        this.natureza = this.$route.query.natureza;
        temQuery = true;
      }

      if ("relator" in this.$route.query) {
        this.relatorDecisorio = this.$route.query.relator;
        temQuery = true;
      }

      if ("processo" in this.$route.query) {
        this.numProcesso = this.$route.query.processo;
        temQuery = true;
      }

      if ("anoProcesso" in this.$route.query) {
        this.anoProcesso = this.$route.query.anoProcesso;
        temQuery = true;
      }

      if (temQuery) {
        this.realizarPesquisabyManyFieldsUrl();
      }
    },
    limparVariaveisFiltro() {
      this.chaveBusca = null;
      this.termosConteudo = null;
      this.anoProcesso = null;
      this.numProcesso = null;
      this.anoDecisorio = null;
      this.numDecisorio = null;
      this.relatorDecisorio = null;
      this.orgaoJulgador = null;
      this.dataSessaoInicio = null;
      this.dataSessaoFim = null;
      this.natureza = null;
      this.pesquisar = false;
    },

    limparVariaveisDados() {
      this.dados = [];
    },

    realizarGetNaturezas() {
      this.$store.state.dlgLoading = true;
      this.decisorioService.getNaturezas().then((data) => {
        setTimeout(() => {
          this.$store.state.dlgLoading = false;
        }, 1000);
        this.listaNaturezasJson = data;
      });
    },

    realizarGetRelatores() {
      this.$store.state.dlgLoading = true;
      this.decisorioService.getRelatores().then((data) => {
        setTimeout(() => {
          this.$store.state.dlgLoading = false;
        }, 1000);
        this.listaRelatoresJson = data;
      });
    },

    realizarPesquisabyChaveBusca() {
      this.$store.state.dlgLoading = true;
      this.limparVariaveisDados();
      this.decisorioService
        .getPesquisarDecisorio(this.chaveBusca)
        .then((data) => {
          setTimeout(() => {
            this.$store.state.dlgLoading = false;
          }, 1000);
          this.dados = data;
        });
      this.limparVariaveisFiltro();
      this.pesquisado = true;
    },

    realizarPesquisabyManyFields() {
      this.$store.state.dlgLoading = true;
      this.limparVariaveisDados();
      this.decisorioService
        .getDecisoriobyManyFields(
          this.termosConteudo,
          this.anoProcesso,
          this.numProcesso,
          this.anoDecisorio,
          this.numDecisorio,
          this.relatorDecisorio,
          this.orgaoJulgador,
          this.dataSessaoInicio,
          this.dataSessaoFim,
          this.natureza
        )
        .then((data) => {
          setTimeout(() => {
            this.$store.state.dlgLoading = false;
          }, 1000);
          this.dados = data;
        });
      // this.limparVariaveisFiltro();
      this.pesquisado = true;
    },
    realizarPesquisabyManyFieldsUrl() {
      this.$store.state.dlgLoading = true;
      this.limparVariaveisDados();
      this.decisorioService
        .getDecisoriobyManyFieldsUrl(
          this.termosConteudo,
          this.anoProcesso,
          this.numProcesso,
          this.anoDecisorio,
          this.numDecisorio,
          this.relatorDecisorio,
          this.orgaoJulgador,
          this.dataSessaoInicio,
          this.dataSessaoFim,
          this.natureza
        )
        .then((data) => {
          setTimeout(() => {
            this.$store.state.dlgLoading = false;
          }, 1000);
          this.dados = data;
        });
      this.limparVariaveisFiltro();
      this.pesquisado = true;
    },

  },

  components: {
    DecisoriosLista,
  },

  mounted() {
    this.decisorioService = new Decisorios();
    this.realizarGetRelatores();
    this.realizarGetNaturezas();

    this.consultarByUrlQuery();
  },
};
</script>

<style scoped>
.fundo-card {
  background-color: #f5f6f8;
  width: 100%;
}

/* Botão de download */
.buscar-btn {
  background: #335e82 !important;
  border-color: #335e82 !important;
  font-weight: 600;
  padding: 0.75rem 1.5rem !important;
  white-space: nowrap;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(51, 94, 130, 0.2);
}
</style>
